import React from 'react';
import { useParams } from 'react-router-dom';
import { useCategory } from '../components/CategoryContext';
import { Container, Table, Image } from 'react-bootstrap';


const CategoryPage = () => {
  const { categories, items } = useCategory();
  const { categoryId } = useParams();
  const category = categories.find((c) => c.url === categoryId);

  // Фильтруем продукты по выбранной категории и элементу
  const filteredItems = items.filter((item) => item.category === categoryId);

  return (
    <div style={{ marginBottom : '250px' }}>
    <Container className='mb-4 mt-4'><div className="row featurette">
      <div className="col-md-7">
        <h1 className="featurette-heading fw-normal lh-1">{category.name}</h1>
        <p>{category.description}</p>
      </div>
      <div className="col-md-5">
        <Image style={{ float: 'right' }} src={category.image} width={300} height={300}/>
      </div>
    </div>
      
      {/* Отображаем отфильтрованные продукты */}
      <Table striped bordered hover variant="dark" responsive>
      <thead>
        <tr>
          <th>Код товара:</th>
          {filteredItems.map((item) => (
            <th key={item.id}>{item.productCode}</th>
          ))}
        </tr>
      </thead>
      <thead>
        <tr>
          <th>Размер:</th>
          {filteredItems.map((item) => (
            <th key={item.id}>{item.size}</th>
          ))}
        </tr>
      </thead>
      <thead>
        <tr>
          <th>Брэнд:</th>
          {filteredItems.map((item) => (
            <th key={item.id}>{item.brand}</th>
          ))}
        </tr>
      </thead>
      <thead>
        <tr>
          <th>Артикул:</th>
          {filteredItems.map((item) => (
            <th key={item.id}>{item.tigerCode}</th>
          ))}
        </tr>
      </thead>
      </Table>
      </Container>
    </div>
  );
};
export default CategoryPage;
